import Steps from 'emerald-ui/lib/Steps';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: Steps, componentName: 'Steps' }], 'Steps'),
  description: 'Shows a sequence of steps for reaching a goal.',
  codeSamples: [
    {
      title: 'Default',
      scope: { Steps },
      whiteBackground: true,
      code: `<Steps step={1} steps={['First', 'Second', 'Third', 'Fourth']} />`,
    },
  ],
};
